import type { Todo } from "../../domain/entities.ts";
import { addDays } from "./recurrence.ts";

export type MatrixQuadrant = "do" | "plan" | "delegate" | "later";
export const matrixQuadrants: readonly MatrixQuadrant[] = ["do", "plan", "delegate", "later"];

export function normalizeUrgencyDays(value: unknown): number {
  const days = Number(value);
  return [0, 1, 3, 7, 14, 30].includes(days) ? days : 3;
}

export function matrixQuadrant(task: Todo, today: string, urgencyDays: number): MatrixQuadrant {
  const important = task.priority === "high" || task.priority === "urgent";
  const urgent = !!task.dueDate && task.dueDate <= addDays(today, normalizeUrgencyDays(urgencyDays));
  return important ? urgent ? "do" : "plan" : urgent ? "delegate" : "later";
}

export function matrixTasks(tasks: Todo[], canSee: (task: Todo) => boolean): Todo[] {
  return tasks.filter(task => !task.deleted && !task.archivedAt && !task.completed && canSee(task));
}

export function matrixReason(task: Todo, today: string, urgencyDays: number, formatDate: (date: string) => string = date => date): string {
  const priority = task.priority === "none" ? "No priority" : `${task.priority[0].toUpperCase()}${task.priority.slice(1)} priority`;
  const deadline = !task.dueDate ? "no deadline" : task.dueDate < today ? `overdue (${formatDate(task.dueDate)})` : task.dueDate === today ? "due today" : task.dueDate <= addDays(today, normalizeUrgencyDays(urgencyDays)) ? `due soon (${formatDate(task.dueDate)})` : `due later (${formatDate(task.dueDate)})`;
  return `${priority} · ${deadline}. Important means high or urgent priority; due soon uses the window in Matrix settings.`;
}
